import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4b2ca58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container content heightContent services" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center l-font-size mb--20" }, "Сервисы и проверки", -1))

import { ServicesAndChecksWidget } from '@/components';

export default /*#__PURE__*/_defineComponent({
  __name: 'Services',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(ServicesAndChecksWidget), { class: "mb--20" })
  ]))
}
}

})